import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import RequestService from './RequestService';

const RequestServicePage = () => {
  return (
    <div className="App">
      <Navbar />
      <RequestService />
      <Footer />
    </div>
  );
};

export default RequestServicePage;